import { CommonModule } from '@angular/common';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, Input, signal } from '@angular/core';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from "ngx-loading";
@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [NgxLoadingModule,CommonModule],

  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  @Input() loading: boolean = false;
  
  config = {
    animationType: ngxLoadingAnimationTypes.circle, // other options include 'wanderingCubes', 'rectangleBounce', etc.
    primaryColour: '#ba7747',
    secondaryColour: '#8A4E24',
    backdropBorderRadius: '4px',
  };
}
